var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.form.prize_name))]),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-form',{attrs:{"label-width":"400px"}},[_c('el-form-item',{attrs:{"label":"中奖单号: "}},[_c('div',[_vm._v(_vm._s(_vm.form.order_sn))])]),_c('el-form-item',{attrs:{"label":"中奖人姓名: "}},[_c('div',[_vm._v(_vm._s(_vm.form.name))])]),_c('el-form-item',{attrs:{"label":"中奖人手机号: "}},[_c('div',[_vm._v(_vm._s(_vm.form.mobile))])]),_c('el-form-item',{attrs:{"label":"收货地址: "}},[_c('div',[_vm._v(_vm._s(_vm.form.address))])]),_c('el-form-item',{attrs:{"label":"奖品类型: "}},[_c('div',{domProps:{"textContent":_vm._s(
									_vm.form.award_type == 1
										? '优惠券'
										: _vm.form.award_type == 2
										? '积分'
										: _vm.form.award_type == 3
										? '实物'
										: _vm.form.award_type == 4
										? '余额'
										: '谢谢参与'
								)}})]),_c('el-form-item',{attrs:{"label":"中奖奖品: "}},[_c('div',[_vm._v(_vm._s(_vm.form.award_name))])]),_c('el-form-item',{attrs:{"label":"图片: "}},[_c('img',{attrs:{"width":"100","src":_vm.form.pic_url,"alt":""}})]),(_vm.form.award_type == 2)?_c('el-form-item',{attrs:{"label":"积分: "}},[_c('div',[_vm._v(_vm._s(_vm.form.integral))])]):_vm._e(),(_vm.form.award_type == 4)?_c('el-form-item',{attrs:{"label":"余额: "}},[_c('div',[_vm._v(_vm._s(_vm.form.balance))])]):_vm._e(),_c('el-form-item',{attrs:{"label":"订单状态: "}},[_c('el-tag',{attrs:{"type":_vm.form.status == 2
										? 'success'
										: _vm.form.status == 1
										? 'warning'
										: 'info'},domProps:{"textContent":_vm._s(
									_vm.form.status == 1
										? '提交'
										: _vm.form.status == 2
										? '完成'
										: '未发货'
								)}})],1)],1)],1),_c('el-col',{attrs:{"span":6}})],1),_c('el-button',{staticStyle:{"margin-left":"50%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.back(-1)}}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }